import { render } from "./BaseDialog.vue?vue&type=template&id=579092e8&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=579092e8&lang=scss&scoped=true"

import exportComponent from "/Users/malina/mySpace/work/v-art/protocol/template-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579092e8"]])

export default __exports__